import Phaser from 'phaser'
import { button } from '../ui/button'
import { THEME } from '../../../kit/theme'
import { LEVEL_POOLS } from '../../../core/holes'

const LEVELS: { id: string; name: string; note: string }[] = [
  { id: '1', name: 'Praça', note: 'buracos abertos' },
  { id: '2', name: 'Parque', note: 'tabelas, areia e rampa' },
  { id: '3', name: 'Clube', note: 'portão em movimento' }
]

export class MenuScene extends Phaser.Scene {
  constructor() { super('Menu') }

  create() {
    const { width, height } = this.scale
    this.cameras.main.setBackgroundColor(THEME.colors.bg)
    const f = (size: number, color: string = THEME.colors.text) => ({ fontFamily: THEME.font.family, fontSize: `${size}px`, color, fontStyle: 'bold' })
    this.add.text(width / 2, height * 0.2, 'Tacada Limpa', f(84)).setOrigin(0.5)
    const sub = this.add.text(width / 2, height * 0.28, 'Minigolfe · 3 buracos · cada tacada conta', f(30, THEME.colors.textDim)).setOrigin(0.5)
    const help = this.add.text(width / 2, height * 0.34, 'Arraste para trás da bola e solte', f(28, THEME.colors.textDim)).setOrigin(0.5)
    const buttons = LEVELS.filter((l) => LEVEL_POOLS[l.id]).map((l, i) =>
      button(this, width / 2, height * 0.48 + i * 160, l.name, () => this.scene.start('Game', { levelId: l.id }), { w: 520, sub: l.note, secondary: i > 0 }))
    this.add.text(width / 2, height * 0.94, 'oferecimento HITZ', f(22, THEME.colors.textDim)).setOrigin(0.5)
    // Blocked screen (spec §2.3): no host or host not allowed → no play buttons. The message comes from the SDK.
    const block = (message: string) => { sub.setText(message); help.setVisible(false); buttons.forEach((b) => b.setVisible(false)) }
    const already = this.registry.get('hitz-blocked') as string | undefined
    if (already) block(already)
    this.registry.events.on('changedata-hitz-blocked', (_p: unknown, v: string) => block(v))
    this.events.once('shutdown', () => this.registry.events.off('changedata-hitz-blocked'))
  }
}
